import { Controller } from '@hotwired/stimulus';

// Ligne qui vient d'être enregistrée (TableComponent) : ramenée dans la vue
// si elle est hors de l'écran (rien pour la version masquée, tableau ou
// carte).
export default class extends Controller {
    connect() {
        if (this.element.offsetParent === null) return;
        this.element.scrollIntoView({ block: 'nearest' });
    }
}
